"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_widgets_1 = require("fmko-ts-widgets");
const fmko_ts_common_1 = require("fmko-ts-common");
const SchemaColumnConfig_1 = tslib_1.__importDefault(require("../schema/SchemaColumnConfig"));
class DeleteRowSchemaColumnConfig extends SchemaColumnConfig_1.default {
    constructor({ heading, minRows = -1, headerStyle = new Set(["delete-row-column-header"]) }) {
        super({ heading, headerStyle, mapDataToTD: () => null });
        this.removeIcons = [];
        this.enabled = true;
        this.onlyLastRowActive = false;
        this.minRows = minRows;
        const that = this;
        this.renderer = {
            render(ctx, _data) {
                const { row, column, currentCell } = ctx;
                const removeIcon = new fmko_ts_widgets_1.ImageWidget({
                    alt: "Slet række",
                    imageDimension: fmko_ts_widgets_1.ImageDimensions.XL,
                    src: fmko_ts_common_1.ImageSrcWithVersion.getImage(fmko_ts_common_1.ImageSrc.CLOSE)
                });
                fmko_ts_common_1.WCAG.addButtonEvent({
                    callback: () => {
                        const data = [...that.grid.getValue()];
                        data.splice(row, 1);
                        const hasMoreThanOneRow = that.grid.getRowCount() > 1;
                        const isFirstRowAndHasMoreThanOneLeft = row === 0 && hasMoreThanOneRow;
                        if (isFirstRowAndHasMoreThanOneLeft) {
                            // Focus itself so SchemaLayout will know to focus the same row and column upon re-rendering
                            that.grid.setLastFocusedCell({ row: row, column });
                        }
                        else if (hasMoreThanOneRow) {
                            // Focus previous row (go 1 up)
                            that.grid.setLastFocusedCell({ row: row - 1, column });
                        }
                        else {
                            that.grid.setLastFocusedCell(null);
                        }
                        that.grid.setValue(data, true);
                    },
                    element: removeIcon.element
                });
                removeIcon.element.addEventListener("focus", () => {
                    currentCell.dispatchEvent(new FocusEvent("focus"));
                });
                fmko_ts_common_1.DOM.setElementTabbable(removeIcon.element, false);
                removeIcon.element.addEventListener("blur", () => {
                    fmko_ts_common_1.DOM.setElementTabbable(removeIcon.element.parentElement, true);
                });
                removeIcon.element.classList.toggle("disabled", !that.enabled);
                removeIcon.element.toggleAttribute("disabled", !that.enabled);
                if (that.onlyLastRowActive && (that.grid.getValue().length - 1) !== row || row < that.minRows) {
                    (0, fmko_ts_common_1.setElementVisible)(removeIcon.element, false);
                    fmko_ts_common_1.DOM.setElementTabbable(currentCell, false);
                }
                that.removeIcons.push(removeIcon);
                ctx.setWidget(removeIcon);
            },
            canRender(_obj) {
                return true;
            }
        };
    }
    getData(data) {
        return { data: data };
    }
    setEnabled(enabled) {
        this.enabled = enabled;
        for (const removeIcon of this.removeIcons) {
            removeIcon.element.classList.toggle("disabled", !this.enabled);
            removeIcon.element.toggleAttribute("disabled", !this.enabled);
        }
    }
    setMinRows(minRows) {
        this.minRows = minRows;
    }
    setOnlyLastRowActive(onlyLastRowActive) {
        this.onlyLastRowActive = onlyLastRowActive;
    }
}
exports.default = DeleteRowSchemaColumnConfig;
//# sourceMappingURL=DeleteRowSchemaColumnConfig.js.map